import { useLayoutEffect, useRef, useState } from "react";
import PDFViewer from "../PDFViewer";

interface Props {
  pdfUrl: string;
  fileTitle: string;
}

function OnboardingPdfFrame({ pdfUrl, fileTitle }: Props) {
  const bodyRef = useRef<HTMLDivElement>(null);
  const [bodyWidth, setBodyWidth] = useState(0);

  useLayoutEffect(() => {
    const body = bodyRef.current;
    if (!body)
      return;
    const observer = new ResizeObserver(([entry]) => setBodyWidth(entry.contentRect.width));
    observer.observe(body);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="absolute inset-x-0 bottom-0 top-[15%] flex items-end justify-center pointer-events-auto">
      <div className="flex flex-col h-full max-w-[90%] aspect-[576/607] bg-white rounded-t-xl border border-b-0 border-[#c4b9ae] overflow-hidden">
        <div className="flex items-center gap-2 px-4 h-9 flex-shrink-0 border-b border-gray-200">
          <span className="flex items-center justify-center w-4 h-4 rounded-sm bg-[#e40a13] font-mono font-bold text-[6px] text-white">PDF</span>
          <span className="font-gilroy font-semibold text-sm text-black truncate">{fileTitle}</span>
          <span className="ml-auto flex gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-gray-300" />
            <span className="w-1.5 h-1.5 rounded-full bg-gray-300" />
            <span className="w-1.5 h-1.5 rounded-full bg-gray-300" />
          </span>
        </div>
        <div ref={bodyRef} className="flex-1 min-h-0">
          {bodyWidth > 0 && (
            <PDFViewer
              pdfUrl={pdfUrl}
              pageWidth={Math.max(bodyWidth - 16, 200)}
              contentClassName="py-2.5 gap-2"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default OnboardingPdfFrame;
